<form [formGroup]="form" (submit)="submit($event)">
  <mat-sidenav-container class="sidenav">
    <mat-sidenav #sidenav [opened]="model.open" (keydown.escape)="close()" mode="over" fixedInViewport="true"
      position="end">
      <div #header class="sidenav-header header-title" fxFlex="none" fxLayout="row"
        fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div class="second-text">{{ "flows.modal.new.title" | translate }}</div>
        </div>
        <div class="close" (click)="close()" color="warn" fxLayoutAlign="center center">
          <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
        </div>
      </div>
      <div appearance="outlined" fxLayout="column" class="flow-new-container">

        <mat-card>
          <div class="mob-fixed-button">
            <div fxLayout="column" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-sm="15px">
              <div fxLayout="row" fxLayoutAlign="center center">
                <div class="flows-icon">
                  <mat-icon aria-hidden="false" aria-label="services" svgIcon="icon_hardware">
                  </mat-icon>
                </div>
              </div>
              <mat-form-field fxFlex>
                <mat-label>{{ "flows.modal.new.name" | translate }}</mat-label>
                <input matInput type="text" formControlName="name" maxlength />
                <mat-error *ngIf="form.controls.name.errors?.required">
                  {{ "flows.modal.new.required" | translate }}
                </mat-error>
                <mat-error *ngIf="
              form.controls.name.errors?.maxlength?.actualLength >
              form.controls.name.errors?.maxlength?.requiredLength
            ">{{ "flows.modal.new.maxlength" | translate }}
                </mat-error>
                <mat-error *ngIf="
              form.controls.name.errors?.minlength?.actualLength <
              form.controls.name.errors?.minlength?.requiredLength
            ">{{ "flows.modal.new.minlength" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field fxFlex>
                <mat-label>{{ "flows.modal.new.description" | translate }}</mat-label>
                <textarea matInput formControlName="description"></textarea>
                <mat-error *ngIf="
              form.controls.description.errors?.maxlength?.actualLength >
              form.controls.description.errors?.maxlength?.requiredLength
            ">{{ "flows.modal.new.maxlength" | translate }}
                </mat-error>
                <mat-hint> {{ "flows.modal.new.hint" | translate }} </mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- <div class="advanced-settings" *ngIf="model.flow_version.status == 0"> -->
            <!-- <div class="advanced-settings-header" (click)="toggleAdvancedSettings()">
              <div class="title">{{ "flows.modal.new.advancedSettings" | translate }}</div>
              <span class="icon" [class.expanded]="showAdvancedSettings">
                <mat-icon aria-hidden="false" aria-label="arrow" svgIcon="icon_arrow_vertical_down">
                </mat-icon>
              </span>
            </div> -->

            <!-- <div class="advanced-settings-content" *ngIf="showAdvancedSettings">
              <div class="form-group">
                <div class="title">{{ "flows.modal.new.flowType" | translate }}</div>
                <mat-radio-group fxLayout="column" formControlName="flow_type_id" class="radio-group"
                  fxLayoutAlign="space-around baseline">
                  <mat-radio-button color="primary" value="0">
                    {{ "flows.modal.new.gatewayFlow" | translate }}

                  </mat-radio-button>
                  <mat-radio-button color="primary" value="1">
                    {{ "flows.modal.new.antifraudFlow" | translate }}
                  </mat-radio-button>
                </mat-radio-group>
                <div class="link">
                  <a class="flows-allowed" target="_blank"
                    href="https://tuna.movidesk.com/kb/pt-br/article/502946/fluxos-de-pagamento?menuId=30493-124241-502946&ticketId=&q=">
                    {{ "flows.modal.new.flowsAllowed" | translate }} </a>
                  <mat-icon svgIcon="icon_arrow_outward" class="icon_arrow_outward">
                  </mat-icon>
                </div>
              </div>
            </div> -->
          <!-- </div> -->
          <div *ngIf="model.user.portal == 'console' && model.user.isUserTuna">
            <div class="fs-12 fc-green c-pointer" (click)="reset()">
              Resetar Fluxo
            </div>
          </div>

          <div fxLayout="row" fxLayoutAlign="center center">
            <button type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
              {{ "flows.modal.new.edit" | translate }}
            </button>
          </div>

        </mat-card>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</form>